import React, { useState } from 'react';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";
import api from "../../../api";

const createInitialForm = () => ({
    user: {},
    loteos: [],
    errors: {},
})

const Modal = (props) =>  {

    const [form, setForm] = useState(createInitialForm());
    const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];

    const getData = () =>  {
        return {
            user_id: form.user.id,
            loteos_ids: form.loteos.map(l => l.id)
        }
    }

    const setInput = (k,v) => {
        let errors = form.errors;
        if (errors) delete errors[k];
        setForm({
            ...form,
            [k]: v,
            errors: errors
        })
    }

    const setData = (data) => {
        if (data.success) {
            setForm({
                user: data.user,
                loteos: data.loteos,
                errors: {},
            });
        }
    }

    const getError = (field) => {
        let errors = form.errors;
        if (errors) return errors[field];
        else return null;
    }

    const modalVars = {
        get: true,
        submitType: "PUT",
        title: "Editar Perfil de Venta para Usuario Vendedor",
        buttonTitle: "Editar",
        danger: false,
        buttonIcon: "fa fa-pencil fa-lg",
        successMessage: "El Perfil de Venta ha sido editado con éxito.",
        saveButton: true,
        saveButtonLabel: "Guardar",
        buttonClass: "",
        disabled: false,
        id: props.id,
        getUrl: api.inversionista.inversionista,
        submitUrl: api.inversionista.inversionista
    }

    const onSubmitcallback = (e)=> {
        props.onSubmit(e);
    };

    return (
        <ParadigmaModal
            onGotData={setData}
            onGotErrors={(errors) => setForm(prevForm => ({ ...prevForm, errors }))}
            onSubmit={onSubmitcallback}
            onClose={() => setForm(createInitialForm())}
            onPreSubmit={getData}
            {...modalVars}
            closeButton={true}
            className="ui-paradigma-modal"
        >
            <section className="ui-modal-section">
                <p className="ui-section-label">Perfil de inversión</p>
                <div className="ui-form-grid">
                    <div className="ui-span-2">
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            maxLength={150}
                            label={"Nombre"}
                            value={form.user.full_name}
                        />
                    </div>
                    <div className="ui-span-2">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={fieldClassNames}
                            label={"Loteos"}
                            error={() => getError('loteos')}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    multiselect={true}
                                    clearable={false}
                                    displayField={'nombre'}
                                    url={api.loteos.loteos_select}
                                    parameters={{
                                        paginationEnabled: false,
                                        sort: ['nombre']
                                    }}
                                    disabled={modalVars.disabled}
                                    value={form.loteos.map(l => l.id)}
                                    onChange={data => setInput('loteos', data)}
                                />
                            }
                        />
                    </div>
                </div>
            </section>
        </ParadigmaModal>
    );
    
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Inversionistas/Configuracion/Modal.js